/** privateRequest.get returns { data: <api body>, status } */
export const parseCarouselsFromResponse = responseData => {
  if (!responseData) return [];

  const body = responseData.data ?? responseData;
  if (!body || typeof body !== "object") return [];

  const payload = body.data ?? body;
  const list = payload?.carousels ?? body.carousels;

  if (Array.isArray(list)) return list;

  if (import.meta.env.DEV) {
    console.warn("[CustomCarousels] Unexpected response shape:", body);
  }

  return [];
};
